// Module
var code = "<div class=\"modal-body clearfix\"> <span class=\"modal-connection-msg\" data-translate>connection.CONNECTION_LOST</span> <span class=\"modal-connection-actions\"><button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"$close('reconnect')\" data-translate>connection.TRY_RECONNECT</button></span> </div> ";
// Exports
var _module_exports =code;;
var path = 'app/desktop.OLD/connectionLostTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;